export default __webpack_public_path__ + "static/media/learning-1.c6c82960.png";